import React from "react";
import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Text,
  Tooltip,
  Divider,
} from "@chakra-ui/react";
import { AddIcon, RepeatIcon, ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { BsListUl, BsGrid } from "react-icons/bs";
import { FiFilter } from "react-icons/fi";
import SearchBox from "../SearchBox";
import SortBy from "../Filter/SortBy";
import { common } from "../../constants/constants";
import { Select } from "@chakra-ui/react";

export const DataToolbar = ({
  title,
  totalRecords,
  addOption,
  createNewRecord,
  onRefresh,
  handleSearch,
  handleClear,
  type,
  sort,
  filterOptions,
  handleCheckboxChange,
  setApply,
  viewMode,
  setViewMode,
  showFilter,
  sortRecords,
  sortOrder,
  currentPage,
  totalPages,
  handlePageChange,
  pagination = true,
  exportHandler,
  showSearch = false,
  showViewToggle = true,
  onFilterToggle,
}) => {
  return (
    <Box
      position={"sticky"}
      zIndex={99}
      top={"0px"}
      bg="white"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={2}
      px={4}
      boxShadow="sm"
      border="1px solid"
      borderColor="gray.100"
      flexShrink={0}
      width="100%"
    >
      <Flex alignItems="center" gap={4}>
        <Text
          fontSize="24px"
          color="gray.800"
          fontWeight="700"
          width={"max-content"}
          letterSpacing="-0.5px"
        >
          {title}
        </Text>
        {totalRecords > 0 && (
          <Box
            display="inline-flex"
            alignItems="center"
            bg="blue.50"
            color="blue.700"
            fontSize="md"
            width={"max-content"}
            fontWeight="600"
            px={3}
            py={1.5}
            borderRadius="full"
            border="1px solid"
            borderColor="blue.200"
            boxShadow="sm"
            _hover={{
              bg: "blue.100",
              borderColor: "blue.300",
              transform: "translateY(-1px)",
            }}
            transition="all 0.2s ease"
          >
            <Text width={"max-content"} fontSize="14px" fontWeight="600">
              {totalRecords.toLocaleString()}{" "}
              {totalRecords === 1 ? "Record" : "Records"}
            </Text>
          </Box>
        )}
        {addOption && (
          <Button
            variant="solid"
            size="md"
            onClick={createNewRecord}
            bg="blue.600"
            color="white"
            px={4}
            py={2}
            borderRadius="lg"
            fontWeight="600"
            fontSize="14px"
            lineHeight={"16px"}
            leftIcon={<AddIcon boxSize={3} />}
            _hover={{
              bg: "blue.700",
              transform: "translateY(-1px)",
              boxShadow: "md",
            }}
            _active={{
              bg: "blue.800",
              transform: "translateY(0)",
            }}
            transition="all 0.2s ease"
            boxShadow="sm"
          >
            {common.ADD_NEW_RECORD}
          </Button>
        )}
      </Flex>

      <Flex alignItems="center" gap={3}>
        {onRefresh && (
          <IconButton
          size="md"
          icon={<RepeatIcon />}
          onClick={onRefresh}
          colorScheme="blue"
          variant="outline"
          borderRadius="lg"
          aria-label={common.REFRESH}
        />
        )}

        {showSearch && <SearchBox onSearch={handleSearch} onClear={handleClear} type={type} />}

        {onFilterToggle && (
          <Button
            size="sm"
            fontSize="14px"
            fontWeight="600"
            onClick={onFilterToggle}
            leftIcon={<FiFilter size={16} />}
            variant={showFilter ? "solid" : "outline"}
            borderColor="blue.300"
            color={showFilter ? "white" : "blue.600"}
            bg={showFilter ? "blue.600" : "white"}
            _hover={{
              bg: showFilter ? "blue.700" : "blue.50",
              borderColor: "blue.400",
              color: showFilter ? "white" : "blue.700",
              transform: "translateY(-1px)",
              boxShadow: "sm"
            }}
            _active={{
              transform: "translateY(0)",
              bg: showFilter ? "blue.800" : "blue.100"
            }}
            transition="all 0.2s ease"
            borderRadius="lg"
            px={4}
            py={2}
            height="36px"
          >
            {common.FILTER}
          </Button>
        )}

         {pagination && totalPages > 0 && (
          <Flex
            alignItems="center"
            gap={3}
            bg="white"
            p={1.5}
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.200"
            boxShadow="sm"
            flexShrink={0}
          >
            <Button
              size="sm"
              fontSize="14px"
              fontWeight="600"
              onClick={() => handlePageChange(Number(currentPage - 1))}
              isDisabled={currentPage === 1}
              variant="outline"
              borderColor="gray.300"
              color="gray.600"
              bg="white"
              leftIcon={<ChevronLeftIcon boxSize={4} />}
              _hover={{
                bg: "gray.50",
                borderColor: "gray.400",
                color: "gray.700",
                transform: "translateY(-1px)",
                boxShadow: "sm"
              }}
              _active={{
                transform: "translateY(0)",
                bg: "gray.100"
              }}
              _disabled={{
                opacity: 0.5,
                cursor: "not-allowed",
                _hover: {
                  transform: "none",
                  boxShadow: "none",
                  bg: "white"
                }
              }}
              transition="all 0.2s ease"
              borderRadius="lg"
              px={4}
              py={2}
              height="36px"
            >
              {common.PREVIOUS}
            </Button>

            <Box
              display="flex"
              alignItems="center"
              bg="gray.50"
              borderRadius="lg"
              border="1px solid"
              borderColor="gray.200"
              px={3}
              py={1}
              minW="120px"
              justifyContent="center"
            >
              <Text fontSize="13px" fontWeight="600" color="gray.600" mr={2}>
                {common.PAGE}
              </Text>
              <Select
                size="sm"
                width="60px"
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                variant="unstyled"
                fontSize="14px"
                fontWeight="700"
                color="blue.600"
                textAlign="center"
                cursor="pointer"
                _hover={{
                  color: "blue.700"
                }}
                _focus={{
                  boxShadow: "none"
                }}
              >
                {totalPages && Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </Select>
              <Text fontSize="13px" fontWeight="500" color="gray.500" ml={1}>
                of {totalPages}
              </Text>
            </Box>

            <Button
              size="sm"
              fontSize="14px"
              fontWeight="600"
              onClick={() => handlePageChange(Number(currentPage + 1))}
              isDisabled={currentPage === totalPages}
              variant="outline"
              borderColor="gray.300"
              color="gray.600"
              bg="white"
              rightIcon={<ChevronRightIcon boxSize={4} />}
              _hover={{
                bg: "gray.50",
                borderColor: "gray.400",
                color: "gray.700",
                transform: "translateY(-1px)",
                boxShadow: "sm"
              }}
              _active={{
                transform: "translateY(0)",
                bg: "gray.100"
              }}
              _disabled={{
                opacity: 0.5,
                cursor: "not-allowed",
                _hover: {
                  transform: "none",
                  boxShadow: "none",
                  bg: "white"
                }
              }}
              transition="all 0.2s ease"
              borderRadius="lg"
              px={4}
              py={2}
              height="36px"
            >
              {common.NEXT}
            </Button>

          </Flex>
        )}

        {exportHandler && (
          <Button
            size="sm"
            fontSize="14px"
            fontWeight="600"
            onClick={exportHandler}
            variant="outline"
            borderColor="blue.300"
            color="blue.600"
            bg="white"
            _hover={{
              bg: "blue.50",
              borderColor: "blue.400",
              color: "blue.700",
              transform: "translateY(-1px)",
              boxShadow: "sm"
            }}
            _active={{
              transform: "translateY(0)",
              bg: "blue.100"
            }}
            transition="all 0.2s ease"
            borderRadius="lg"
            px={4}
            py={2}
            height="36px"
          >
            {common.EXPORT}
          </Button>
        )}
        {sort && sort?.length > 0 && filterOptions && (
          <SortBy
            sort={sort}
            filterOptions={filterOptions}
            handleCheckboxChange={handleCheckboxChange}
            setApply={setApply}
          />
        )}

        {sortRecords && (
          <Box display="flex" justifyContent="flex-end">
            <Tooltip label="Sort Titles">
              <Button
                size="md"
                onClick={sortRecords}
                variant="outline"
                _hover={{ bg: "#e8e8e8" }}
              >
                <Text fontSize="22px">{sortOrder === "asc" ? "↓" : "↑"}</Text>
              </Button>
            </Tooltip>
          </Box>
        )}

       

        {showViewToggle && (
          <HStack
            bg="gray.50"
            p={1}
            borderRadius="lg"
            border="1px solid"
            borderColor="gray.200"
            spacing={0}
          >
            <IconButton
              icon={<BsListUl size={20} />}
              variant="ghost"
              size="sm"
              isActive={viewMode === "list"}
              onClick={() => setViewMode("list")}
              bg={viewMode === "list" ? "white" : "transparent"}
              color={viewMode === "list" ? "blue.600" : "gray.500"}
              boxShadow={viewMode === "list" ? "sm" : "none"}
              _hover={{ bg: viewMode === "list" ? "white" : "gray.100" }}
              aria-label="List View"
            />
            <Divider orientation="vertical" height="20px" mx={1} />
            <IconButton
              icon={<BsGrid size={18} />}
              variant="ghost"
              size="sm"
              isActive={viewMode === "grid"}
              onClick={() => setViewMode("grid")}
              bg={viewMode === "grid" ? "white" : "transparent"}
              color={viewMode === "grid" ? "blue.600" : "gray.500"}
              boxShadow={viewMode === "grid" ? "sm" : "none"}
              _hover={{ bg: viewMode === "grid" ? "white" : "gray.100" }}
              aria-label="Grid View"
            />
          </HStack>
        )}
      </Flex>
    </Box>
  );
};
